import { render, staticRenderFns } from "./Pleurisy.vue?vue&type=template&id=1f47b437&scoped=true&v-if=currentReportDetails&"
import script from "./Pleurisy.vue?vue&type=script&lang=ts&"
export * from "./Pleurisy.vue?vue&type=script&lang=ts&"
import style0 from "./Pleurisy.vue?vue&type=style&index=0&id=1f47b437&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f47b437",
  null
  
)

export default component.exports